import styled from 'styled-components';
import { layout, media, remCalc } from 'src/components/base';

export const Header = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  padding: ${layout.measurements.spacing250} ${layout.measurements.spacing100};

  ${media.mediumDown`
    display: block;
    padding: ${layout.measurements.spacing050} 0;
  `}
`;

export const Container = styled.div`
  display: flex;
  flex-grow: 5;
  min-height: 164px;

  ${media.largeUp`
    .legacy & {
      width: 65%;
    }
  `}

  ${media.mediumDown`
    min-height: 0;
    width: 100%;
    flex-wrap: wrap;
    align-items: flex-start;
    padding: 0 20px;
  `}
`;

export const Logo = styled.div`
  text-align: center;
  & img {
    max-width: 150px;
  }

  ${media.mediumDown`
    & img {
      max-width: 65px;
    }
  `}
`;

export const Title = styled.h1`
  text-align: left;
  color: #000;
  & strong {
    font-weight: inherit;
    color: #d00;
  }
`;

export const Content = styled.div`
  min-width: 0;
  padding-left: 30px;
  flex-grow: 1;

  & h1 {
    font-weight: normal;
    font-size: ${remCalc(22)};
  }

  & p {
    color: ${props => props.theme.text.secondary};
  }

  ${media.largeUp`
    .legacy & {
      padding-right: 30px;
    }
  `}

  ${media.mediumDown`
    padding-left: 20px;
    & h1 {
      font-size: ${remCalc(18)};
    }
    & p {
      font-weight: ${remCalc(13)};
    }
  `}
`;

export const LogoAndText = styled.div`
  display: flex;
  flex-grow: 1;
  margin-bottom: ${layout.measurements.spacing050};
  ${media.mediumDown`
    display: flex;
    flex-wrap: nowrap;
    min-width: 100%;
  `}
`;

export const PeakIndex = styled.div`
  min-width: 200px;
  width: 200px;
  padding-left: 30px;
  margin-bottom: ${layout.measurements.spacing050};
  &:empty {
    display: none;
  }
  ${media.mediumDown`
    min-width: 100%;
    width: 100%;
    padding-left: 0;
  `}
`;

export const Ads = styled.div`
  width: 100%;
`;
